import axios from "axios";

const BASE = "/ncrm/demo-data";

export const fetchDemoDataStatus = () => axios.get(`${BASE}/status`);

export const deleteDemoData = (confirmation) =>
  axios.post(`${BASE}/delete`, { confirmation });

// Roles allowed to remove the demo graph. Mirrors the backend guard, so the
// button is not offered to someone the API would refuse.
export const DEMO_DELETE_ROLES = Object.freeze(["admin", "miniadmin"]);

export const canDeleteDemoData = (roles = []) => {
  const normalized = new Set(
    (Array.isArray(roles) ? roles : [])
      .map((role) => String(role?.key || role || "").trim().toLowerCase())
      .filter(Boolean)
  );
  return DEMO_DELETE_ROLES.some((role) => normalized.has(role));
};
